import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { getSelfServeAmendDetails } from 'src/api/amendService';
import { SelfServeAmendDetails } from 'src/api/amendService/types';

import { AuthContext } from '../../providers/auth-context';

export const useGetSelfServeAmendDetails = (bookingId: string | null) => {
    const userState = useContext(AuthContext);

    return useQuery<SelfServeAmendDetails, AxiosError, SelfServeAmendDetails>({
        enabled: userState.loggedIn && !!bookingId,
        queryKey: ['self-serve-amend-details', bookingId],
        queryFn: async () => {
            if (!bookingId) throw new Error('Booking ID is required');
            return getSelfServeAmendDetails(bookingId);
        },
    });
};
